import { DELETE_ALL_ERRORS, DELETE_ERROR, SET_ERROR } from '../actions'

// Keeps track of how many errors exist on an interactive so 
// we can give a warning on export. 
export default (errors = {}, action) => {
  switch (action.type) {
    case SET_ERROR: 
      return {
        ...errors, 
        [action.payload.id]: action.payload.path
      };
    case DELETE_ERROR: 
      const newErrors = {...errors};
      delete newErrors[action.payload];
      return newErrors;
    case DELETE_ALL_ERRORS: 
      return {}
    default:
      return errors;
  }
 
}